import HTTP from "../http";
import Jsona from "jsona";
import paramsHelper from "../helpers/params";

const dataFormatter = new Jsona();

export default {
  async getConfigurableFieldByModel(model) {
    try {
      const filters = [{ name: "model", value: model }];

      const params = paramsHelper.buildParams({ filters });

      const results = await HTTP.normal.get(`/configurable-fields${params}`);

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (_) {
      throw "Ocorreu um erro ao listar as preferências!";
    }
  },

  async getConfigurableFieldByKey(key) {
    try {
      const filters = [{ name: "key", value: key }];
      const params = paramsHelper.buildParams({ filters });

      const results = await HTTP.normal.get(`/configurable-fields${params}`);
      const serializedResults = dataFormatter.deserialize(results.data);

      return serializedResults.length < 1 ? {} : serializedResults[0];
    } catch (_) {
      throw "Ocorreu um erro ao buscar a preferência!";
    }
  },

  async show(id) {
    try {
      const configurableField = await HTTP.normal.get(
        `/configurable-fields/${id}`
      );

      return dataFormatter.deserialize(configurableField.data);
    } catch (_) {
      throw "Ocorreu um erro ao buscar a preferência!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/configurableFields.js